// extracted by mini-css-extract-plugin
module.exports = {"icon":"j_bj","font-size-small":"j_bk","fontSizeSmall":"j_bk","font-size-default":"j_bl","fontSizeDefault":"j_bl","font-size-large":"j_bm","fontSizeLarge":"j_bm"};